import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal", "frame" ]

  connect() {
    this.handleEscape = this.handleEscape.bind(this)
    this.handleBeforeCache = this.handleBeforeCache.bind(this)

    document.addEventListener("keydown", this.handleEscape)
    document.addEventListener("turbo:before-cache", this.handleBeforeCache)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache)
    this.resetBodyOverflow()
  }

  open(event) {
    const modal = this.resolveModal(event)
    if (!modal) return

    if (this.hasFrameTarget && !this.frameTarget.src) {
      const src = this.frameTarget.dataset.src
      if (src) this.frameTarget.src = src
    }

    this.openModal(modal)
  }

  close(event) {
    const modal = this.resolveModal(event) || this.openedModal()
    if (!modal) return

    this.closeModal(modal)
  }

  closeOnBackdrop(event) {
    const modal = this.resolveModal(event)
    if (!modal) return
    if (event.target !== modal) return

    this.closeModal(modal)
  }

  handleEscape(event) {
    if (event.key !== "Escape") return

    this.modalTargets.forEach((modal) => {
      if (!this.modalHidden(modal)) this.closeModal(modal)
    })
  }

  handleBeforeCache() {
    this.modalTargets.forEach((modal) => this.closeModal(modal))
  }

  resolveModal(event) {
    const name = event?.params?.modal || event?.currentTarget?.dataset.modalName
    if (name) {
      const modal = this.modalTargets.find((target) => target.dataset.modalName === name)
      if (modal) return modal
    }

    if (this.modalTargets.length === 1) return this.modalTargets[0]

    return null
  }

  openedModal() {
    return this.modalTargets.find((modal) => !this.modalHidden(modal))
  }

  openModal(modal) {
    modal.classList.remove("hidden")
    modal.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  closeModal(modal) {
    modal.classList.add("hidden")
    modal.classList.remove("flex")
    this.resetBodyOverflow()
  }

  modalHidden(modal) {
    return modal.classList.contains("hidden")
  }

  resetBodyOverflow() {
    const openedModalExists = this.modalTargets.some((modal) => !this.modalHidden(modal))
    if (!openedModalExists) {
      document.body.style.overflow = ""
    }
  }
}
